module.exports = __webpack_public_path__ + "img/sample2.767af933.png";